var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "scalar-wrapper"
  }, _vm._l(_vm.sortedMetrics, function (row, row_idx) {
    return _c('div', {
      key: row_idx,
      class: ['metric-row', row.classes]
    }, [_c('h2', {
      staticClass: "h5 plot-caption"
    }, [_c('span', {
      staticClass: "plot-title"
    }, [_vm._v(_vm._s(row.label))]), row.info ? _c('v-tooltip', {
      attrs: {
        "bottom": "",
        "max-width": "320",
        "content-class": "metric-tooltip"
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function (_ref) {
          var on = _ref.on;
          return [_c('v-icon', _vm._g({
            staticClass: "metric-help-icon"
          }, on), [_vm._v(" mdi-help-circle-outline ")])];
        }
      }], null, true)
    }, [_c('p', {
      staticClass: "metric-tooltip-text",
      domProps: {
        "innerHTML": _vm._s(row.info.replace(/\n/g, '<br>'))
      }
    })]) : _vm._e()], 1), _c('div', {
      staticClass: "scalar-plot-container d-flex",
      staticStyle: {
        "margin-top": "40px",
        "margin-bottom": "30px"
      }
    }, [_c('div', {
      staticClass: "scalar-plot-bar scalar-plot-bar-left text-right",
      style: _vm.buildBarStyles(row, 'left')
    }, [_c('div', {
      staticStyle: {
        "position": "relative",
        "margin-top": "20px"
      }
    }, [_vm._v(_vm._s(row.min_limit))])]), _c('div', {
      staticClass: "scalar-plot-bar scalar-plot-bar-middle",
      style: _vm.buildBarStyles(row, 'middle')
    }, [_c('div', {
      style: _vm.buildValueStyles(row.value, row.min_limit, row.max_limit)
    }, [_c('div', {
      staticStyle: {
        "width": "100px",
        "text-align": "center",
        "margin-left": "-50px"
      }
    }, [_vm._v(_vm._s(row.value))]), _c('div', {
      staticStyle: {
        "border": "1px solid var(--app-text-primary)",
        "width": "4px",
        "height": "30px",
        "background": "var(--app-text-primary)"
      }
    })])]), _c('div', {
      staticClass: "scalar-plot-bar scalar-plot-bar-right",
      style: _vm.buildBarStyles(row, 'right')
    }, [_c('div', {
      staticStyle: {
        "position": "relative",
        "margin-top": "20px"
      }
    }, [_vm._v(_vm._s(row.max_limit))])])])]);
  }), 0);

}
var staticRenderFns = []

export { render, staticRenderFns }